import {
  faCaretDown,
  faCaretUp,
  faLink,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeFormulaType,
  changeFormulaTypeFromDays,
  changeFormulaTypeFromGranularToRaw,
  editFormulaHerbItem,
  editSingleHerbItem,
  removeHerbFromFormula,
  removeItemFromSingleHerbList,
} from "../../actions/formulaAction";
import { getFixedDosage, getUserDetail } from "../../utils/helper";
const HerbItem = ({
  rawGramPerDayBeforeConversion,
  herb,
  totalDosage,
  isLocked,
  isRawType,
  formulaId,
  isOuterLocked,
  canEditPercentage,
  isSuntenFormula = false,
}) => {
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(false);
  const [isOutOfStock, setIsOutOfStock] = useState();
  const [herbPercentange, setHerbPercentage] = useState(0);
  const role = useSelector((state) => state.role.role);
  const isAllowed = getUserDetail()?.practitioner_status == 1;
  const formulaSection = useSelector(
    (state) => state.formula.present.formulaSection
  );
  const overall = useSelector((state) => state.formula.present.overall);
  const [tempValue, setTempValue] = useState(herb.dosage.toString());
  useEffect(() => {
    setIsActive(!herb.granularPrice == 0 || herb.granularQuantity > 0);
    setIsOutOfStock(false);
  }, [isRawType]);

  const updateHerb = (dosage) => {
    dosage = isNaN(dosage) ? 0 : dosage;
    dosage = getFixedDosage(dosage);
    if (formulaId > 0) {
      if (!isRawType) {
        let newdosage = (dosage * herb.rawRatio) / herb.granularUnit;

        dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
        dispatch(
          editFormulaHerbItem(
            formulaId,
            herb.id,
            newdosage,
            isLocked,
            isOuterLocked
          )
        );
        dispatch(changeFormulaTypeFromDays(false, 1));
      } else {
        dispatch(
          editFormulaHerbItem(
            formulaId,
            herb.id,
            dosage,
            isLocked,
            isOuterLocked
          )
        );
      }
    } else {
      if (!isRawType) {
        let newdosage = (dosage * herb.rawRatio) / herb.granularUnit;

        dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
        dispatch(
          editSingleHerbItem(herb.id, newdosage, isLocked, isOuterLocked)
        );
        dispatch(changeFormulaTypeFromDays(false, 1));
      } else {
        dispatch(editSingleHerbItem(herb.id, dosage, isLocked, isOuterLocked));
      }
    }
  };

  const updateHerbPercentage = (dosage) => {
    if (formulaId > 0) {
      dispatch(
        editFormulaHerbItem(
          formulaId,
          herb.id,
          parseFloat(dosage),
          isLocked,
          isOuterLocked
        )
      );
    } else {
      dispatch(
        editSingleHerbItem(herb.id, parseFloat(dosage), isLocked, isOuterLocked)
      );
    }
  };

  useEffect(() => {
    setIsOutOfStock(
      herb.dosage > herb.granularQuantity || herb.granularQuantity == 0
    );
    const percentage = herb.percentage;
    setHerbPercentage(((isNaN(percentage) ? 0 : percentage) * 100)?.toFixed(1));
    setTempValue(herb.dosage);
  }, [herb.dosage, totalDosage, formulaSection]);

  return (
    <tr
      className={`herb-item ${
        isActive
          ? !isOutOfStock
            ? herb.isToxic
              ? "toxic-herb"
              : ""
            : "inactive"
          : "inactive"
      } `}
    >
      <td className={`cross  `}>
        {!isSuntenFormula ? (
          <FontAwesomeIcon
            style={{
              cursor: isRawType
                ? "pointer"
                : rawGramPerDayBeforeConversion != null &&
                  (!isActive || isOutOfStock)
                ? "pointer"
                : rawGramPerDayBeforeConversion == null
                ? "pointer"
                : "not-allowed",
              opacity: isRawType
                ? 1
                : rawGramPerDayBeforeConversion != null &&
                  (!isActive || isOutOfStock)
                ? 1
                : rawGramPerDayBeforeConversion == null
                ? 1
                : 0.5,
            }}
            icon={faTimesCircle}
            onClick={() => {
              if (
                isRawType ||
                (!isRawType &&
                  rawGramPerDayBeforeConversion != null &&
                  (!isActive || isOutOfStock)) ||
                (!isRawType && rawGramPerDayBeforeConversion == null)
              ) {
                if (formulaId > 0) {
                  if (!isRawType) {
                    dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
                    dispatch(removeHerbFromFormula(formulaId, herb.id));
                    dispatch(changeFormulaTypeFromDays(false, 1));
                  } else {
                    dispatch(removeHerbFromFormula(formulaId, herb.id));
                  }
                } else {
                  if (!isRawType) {
                    dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
                    dispatch(removeItemFromSingleHerbList(herb.id));
                    dispatch(changeFormulaTypeFromDays(false, 1));
                  } else {
                    dispatch(removeItemFromSingleHerbList(herb.id));
                  }
                }
              }
            }}
          />
        ) : null}
      </td>
      <td>
        {herb.name}
        {herb.isToxic ? " - Caution" : ""}
      </td>
      {console.log(rawGramPerDayBeforeConversion)}
      {isActive ? (
        <td className="text-right">
          {(role.val === 4 && herb.isToxic) ||
          (!isRawType && rawGramPerDayBeforeConversion != null) ? (
            <label
              className="pr-5"
              style={{ marginBottom: 0, marginRight: "30px" }}
            >
              {parseFloat(herb.dosage).toFixed(1)}
            </label>
          ) : (
            <div className="d-flex justify-content-end pr-4 ">
              {!isRawType && (
                <button
                  disabled
                  type="button"
                  className={`lock-btn ${isLocked ? "unhide" : "hide"}`}
                >
                  <FontAwesomeIcon icon={faLink} />
                </button>
              )}

              <div className="number-field">
                <input
                  type="number"
                  min="0"
                  step="any"
                  value={tempValue}
                  onChange={(e) => setTempValue(e.target.value)}
                  onBlur={(e) => {
                    const parsedValue = parseFloat(e.target.value);
                    if (!isNaN(parsedValue)) {
                      updateHerb(parsedValue);
                    } else {
                      updateHerb(0);
                      setTempValue("0");
                    }
                  }}
                />
                <div>
                  <div
                    className="icon"
                    onClick={() => updateHerb(herb.dosage + 0.5)}
                  >
                    <FontAwesomeIcon icon={faCaretUp} />
                  </div>
                  <div
                    className="icon"
                    onClick={() =>
                      parseFloat(herb.dosage) > 0
                        ? updateHerb(herb.dosage - 0.5)
                        : updateHerb(0)
                    }
                  >
                    <FontAwesomeIcon icon={faCaretDown} />
                  </div>
                </div>
              </div>
            </div>
          )}
        </td>
      ) : (
        <td className="text-right">
          <label
            className="pr-5"
            style={{ marginBottom: 0, marginRight: "30px" }}
          >
            {herb.dosage?.toFixed(1)}
          </label>
        </td>
      )}

      <td className="text-right ">
        <>{herbPercentange} % </>
        {/* {isRawType || rawGramPerDayBeforeConversion > 0 ? (
          <>{herbPercentange} % </>
        ) : (
          <div className="d-flex justify-content-end ">
            <div className="number-field">
              <input
                type="number"
                min="0"
                step="any"
                value={herbPercentange}
                onChange={(e) => {
                  isNaN(parseFloat(e.target.value))
                    ? updateHerb(0)
                    : setHerbPercentage(parseFloat(e.target.value));
                }}
                onBlur={(e) => {
                  let dosage =
                    herb.dosageInFloat *
                    (parseFloat(e.target.value) / (herb.percentage * 100));
                  if (dosage < 0) dosage = 0;
                  updateHerb(dosage);
                }}
              />
              <div>
                <div
                  className="icon"
                  onClick={() => {
                    let dosage =
                      herb.dosageInFloat *
                      ((parseFloat(herbPercentange) + 1) /
                        (herb.percentage * 100));
                    if (dosage < 0) dosage = 0;
                    updateHerb(dosage);
                  }}
                >
                  <FontAwesomeIcon icon={faCaretUp} />
                </div>
                <div
                  className="icon"
                  onClick={() => {
                    let dosage =
                      herb.dosageInFloat *
                      ((parseFloat(herbPercentange) - 1) /
                        (herb.percentage * 100));
                    if (dosage < 0) dosage = 0;
                    updateHerb(dosage);
                  }}
                >
                  <FontAwesomeIcon icon={faCaretDown} />
                </div>
              </div>
            </div>
          </div>
        )} */}
      </td>
      {!isRawType && (
        <td className="text-right">
          {herb?.rawRatio}
          {herb?.rawRatio && herb?.granularUnit && ":"}
          {herb.granularUnit}
        </td>
      )}
      {!isRawType && isAllowed && (
        <td className="text-right">
          {isActive
            ? !isOutOfStock
              ? role.val === 4 && herb.isToxic
                ? "Caution"
                : `${herb?.price?.toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "USD",
                  })}`
              : `Only ${parseFloat(herb?.granularQuantity)?.toFixed(
                  1
                )} gram(s) remaining in stock`
            : "Not Available"}
        </td>
      )}
      <td></td>
    </tr>
  );
};
export default HerbItem;
